import { API_ROUTES } from "@/lib/config/api-routes";
import { vehicleSearchPayloadToQueryParams } from "@/lib/booking/search-params";
import { ApiService } from "@/lib/services/api-service";
import type {
  VehicleSearchPayload,
  VehiclesApiResponse,
} from "@/lib/types/vehicle";

class VehiclesService extends ApiService {
  fetchVehicles(payload: VehicleSearchPayload) {
    return this.get<VehiclesApiResponse>(API_ROUTES.vehicles, {
      params: vehicleSearchPayloadToQueryParams(payload),
    });
  }
}

export const vehiclesService = new VehiclesService();
